export const getLicenseKey = () => "";

export const pricingPageUrlSource = "CE";

export const ShowUpgradeMenuItem = () => null;

export const Banner = () => null;
